import React from 'react';
import './AnimeCardComponent.css';

const AnimeCardSkeleton = () => {
    return (
        <div className="anime-card anime-card-skeleton" aria-hidden="true">
            <div className="anime-card-shimmer" />
        </div>
    );
};

export default AnimeCardSkeleton;

